var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeCommit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616 232H477.582C465.924 155.109 400.145 96 320 96S174.076 155.109 162.418 232H24C10.75 232 0 242.75 0 256S10.75 280 24 280H162.418C174.076 356.891 239.855 416 320 416S465.924 356.891 477.582 280H616C629.25 280 640 269.25 640 256S629.25 232 616 232ZM320 368C258.242 368 208 317.758 208 256S258.242 144 320 144S432 194.242 432 256S381.758 368 320 368Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCommit);
export default __webpack_public_path__ + "static/media/code-commit.979c17614dcad5ca4224f73f758cc31b.svg";
export { ForwardRef as ReactComponent };